module.exports = __webpack_public_path__ + "img/3470ca4.jpg";